const initialState = {
  stepCompleted: false,
  passenger: null,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'SET_PASSENGER': {
      return {
        ...state,
        passenger: action.payload.passenger,
        stepCompleted: true,
      }
    }

    default: {
      return state
    }
  }
}
